export default {
    "name": "UpdateDashboardChart",
    "kind": "HoudiniMutation",
    "hash": "1083333f05d42b8ed2224a6eac6de4aa783ac669996ff23c46686890ecb799c7",

    "raw": `mutation UpdateDashboardChart($input: UpdateDashboardChartInput!) {
  updateDashboardChart(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateDashboardChart": {
                "type": "DashboardChart",
                "keyRaw": "updateDashboardChart(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "UpdateDashboardChartInput"
        },

        "types": {
            "UpdateDashboardChartInput": {
                "description": "String",
                "id": "UInt",
                "jsonString": "String",
                "name": "String",
                "showChart": "Boolean",
                "title": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=605c729b9e00c8c5e535879418533438c4f76171ee48a0622435fd924d2f3ebd";